export default "__VITE_ASSET__BD63$60P__"